import React, { useContext } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import ContentCard from "../../../../components/ContentCard"
import { Content, FavoriteFolderFrame } from "./displays"
import FolderPreview from "./FolderPreview"
import FolderEdit from "./FolderEdit"
import AppContext from "../../../../shared/AppContext"
import "./style.scss"

export default function FavoriteFolder(props) {
  const {
    name,
    count,
    className,
    style,
    onViewAllClick,
    favoritesFiles,
    id,
    refetch,
    trackingLocation,
  } = props

  const { trackEvent } = useContext(AppContext)

  return (
    <ContentCard className="favorite-folder" style={style}>
      <FavoriteFolderFrame className={className}>
        <Link
          to={`/favorites/${id}`}
          onClick={() =>
            trackEvent("Favorite Folder", {
              link: `favorites/${id}`,
              location: trackingLocation,
            })
          }
        >
          <Content name={name} count={count} />
        </Link>
        <div className="folder-edit-mobile">
          <FolderEdit
            folderId={id}
            folderName={name}
            refetch={refetch}
            trackingLocation={trackingLocation}
          />
        </div>
        <FolderPreview
          folderId={id}
          folderName={name}
          style={{ width: "450px" }}
          trackEvent={trackEvent}
          viewAllLink={`/favorites/${id}`}
          onViewAllClick={() => onViewAllClick(id)}
          favoritesFiles={favoritesFiles}
          refetch={refetch}
          count={count}
          trackingLocation={trackingLocation}
        />
      </FavoriteFolderFrame>
    </ContentCard>
  )
}

FavoriteFolder.defaultProps = {
  count: 0,
}

FavoriteFolder.propTypes = {
  count: PropTypes.number,
  name: PropTypes.string,
  files: PropTypes.array,
}
